export const name = 'sessionManagerService' as const
